module.exports = __webpack_public_path__ + "static/transformation-for-all-3747e0b09f575dcff9406805c6d80c70.png";